import React from 'react';
import { useTranslation } from 'react-i18next';
import { GlassCard } from '../components/ui/GlassCard';

export const Docs = () => {
  const { t } = useTranslation();

  const cards = [
    { title: t('docs.quickstartTitle'), desc: t('docs.quickstartDesc') },
    { title: t('docs.apiRefTitle'), desc: t('docs.apiRefDesc') },
    { title: t('docs.guidesTitle'), desc: t('docs.guidesDesc') },
    { title: t('docs.sdksTitle'), desc: t('docs.sdksDesc') },
  ];

  return (
    <div className="container mx-auto px-6 py-20">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-display font-bold mb-12">{t('docs.title')}</h1>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {cards.map((card, i) => (
            <GlassCard key={i} className="p-8 hover:border-glass-cyan cursor-pointer group">
              <h2 className="text-2xl font-bold mb-4 group-hover:text-glass-cyan transition-colors">{card.title}</h2>
              <p className="text-gray-400">{card.desc}</p>
            </GlassCard>
          ))}
        </div>
      </div>
    </div>
  );
};
